export default __webpack_public_path__ + "static/media/hht2_ep10_timeline_q01_b.f6e02a08.png";